// The example shown in the add-to-list dialog, per list.
//
// One hard-coded pair used to serve every list, so a BD adding a currency was shown a fuel grade.
// The example is the only guidance on the dialog about the shape of a value, and an example from
// the wrong list is worse than none - it invites EN590-shaped currency codes.
//
// These mirror the seeded entries in 0006_seed_reference_lists.py. They are illustrations, not a
// contract: a list that gains entries here does not need this file changed, and a list with no
// entry renders without a placeholder rather than borrowing another list's.

const SAMPLES = {
  product: { value: 'GASOIL', displayName: 'Gasoil' },
  grade: { value: 'EN590_10PPM', displayName: 'EN590 10ppm' },
  unit: { value: 'MT', displayName: 'Metric tonnes' },
  currency: { value: 'USD', displayName: 'US dollar' },
  incoterms: { value: 'FOB', displayName: 'FOB - Free On Board (Incoterms 2020)' },
  payment_terms: { value: 'LC_30', displayName: 'Letter of credit 30 days' },
};

const NONE = { value: '', displayName: '' };

export function sampleFor(listName) {
  return SAMPLES[listName] ?? NONE;
}
